import { NgModule }      from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { FormsModule }   from '@angular/forms';
import { routing } from './app.routing';
import { AppComponent }   from './app.component';
import { MissionService }   from './app.constant';
import {enableProdMode} from '@angular/core';
import { LoginComponent }   from './login/login.component';
import { LoginService }   from './login/login.service';
import { DispatcherHomeService }   from './dispatcher/dispatcherhome/dispatcherhome.service';
import { DispatcherComponent }   from './dispatcher/dispatcher.component';
import { DispatcherService }   from './dispatcher/dispatcher.service';
import { DispatcherHomeComponent }   from './dispatcher/dispatcherhome/dispatcherhome.component';
import { TasksComponent }   from './dispatcher/tasks/tasks.component';
import { WalletComponent }   from './dispatcher/wallet/wallet.component';
import { AccountComponent }   from './dispatcher/account/account.component';
import { AccountService }   from './dispatcher/account/account.service';
import { ReactiveFormsModule } from '@angular/forms';
import { Angular2SocialLoginModule } from "angular2-social-login";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SearchPipe } from './dispatcher/pipes/search.pipe';
import { LanguageService } from './language.service';
import { AuthService } from './auth.service';
import { AuthGaurdService } from './auth-gaurd.service';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { ConfigService } from './config.service';
import { HaversineService } from 'ng2-haversine';
import { MqttService } from './mqtt.service';
// import { DistanceMatrix } from 'google-distance-matrix';
import { BookingPopupComponent } from './dispatcher/booking-popup/booking-popup.component';
import { BookingPopupService } from './dispatcher/booking-popup/booking-popup.service';
let providers = {
    "google": {
      "clientId": "1093081887013-oscbmlo46sdk080e2jst8b4g934ucr6m.apps.googleusercontent.com"
    }, 
    "facebook": {
      "clientId": "404038860365252",
      "apiVersion": "v2.12" //like v2.4 
    }
  };

@NgModule({
  imports:[
     BrowserModule,
     FormsModule,
     ReactiveFormsModule,
     HttpModule,
     routing,
     Angular2SocialLoginModule,
     BrowserAnimationsModule
   ], 
  declarations: [
     AppComponent,
     AccountComponent,
     LoginComponent,
     DispatcherComponent,
     DispatcherHomeComponent,
     TasksComponent,
     SearchPipe,
     WalletComponent,
     BookingPopupComponent
     ],
  providers: [MissionService, LoginService,
  DispatcherService,
  DispatcherHomeService,
  AccountService,
  LanguageService,
  AuthService,
  AuthGaurdService,
  ConfigService,
  HaversineService,
  MqttService,
  BookingPopupService
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
Angular2SocialLoginModule.loadProvidersScripts(providers);



// WEBPACK FOOTER //
// F:/Karry/Zoom/ZoomCustomer/src/app/app.module.ts